// Raqmoon Frontend - Production Sync: 2026-02-25
// Raqmoon Frontend - Deployment Trigger 2026-03-05
import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import { createPinia } from 'pinia';
import { remoteLogger } from './services/remoteLoggingService';
import { initConsoleFilter } from './utils/consoleFilter';

import { Quasar, Notify, Dialog, Loading } from 'quasar';
import '@quasar/extras/material-icons/material-icons.css';
import '@quasar/extras/material-icons-outlined/material-icons-outlined.css';
import 'quasar/dist/quasar.css';
import '../style.css';

const app = createApp(App);
const pinia = createPinia();

// --- Global Error Handling ---
// Vue specific errors
app.config.errorHandler = (err, instance, info) => {
  console.error('Vue Error:', err, info);
  const stack = err.stack;
  const message = `Vue Error: ${err.message} (in ${info})`;
  remoteLogger.error(message, stack);
  // Optionally, re-throw the error if you have other error reporting integrations
  // throw err;
};

// Unhandled promise rejections
window.addEventListener('unhandledrejection', (event) => {
  console.error('Unhandled Promise Rejection:', event.reason);
  const message = `Unhandled Promise Rejection: ${event.reason?.message || 'No message'}`;
  const stack = event.reason?.stack || 'No stack trace available';
  remoteLogger.error(message, stack);
});
// --- End Global Error Handling ---

app.use(router);
app.use(pinia);

app.use(Quasar, {
  plugins: {
    Notify,
    Dialog,
    Loading
  },
  config: {
    notify: {
      position: 'top',
      timeout: 2500,
      textColor: 'white',
      actions: [{ icon: 'close', color: 'white' }],
    },
    dark: 'auto',
  },
});

document.documentElement.setAttribute('lang', 'ar');
document.documentElement.setAttribute('dir', 'rtl');

// منع ظهور زر/بانر تثبيت PWA التلقائي في Chrome.
// التثبيت يبقى ممكناً يدوياً عبر قائمة المتصفح (⋮ → تثبيت التطبيق)،
// لكن لا نريد دفع المستخدمين لتثبيته تلقائياً لأن صفحات الدفع الخارجية
// (Chargily / بريد الجزائر) تعمل بشكل أفضل في المتصفح العادي.
window.addEventListener('beforeinstallprompt', (event) => {
  event.preventDefault();
});

// 🔥 تسجيل الـ Service Worker الخاص بالإشعارات يدوياً بذكاء
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    // التحقق إذا كان مسجلاً مسبقاً لتجنب الحلقات اللانهائية
    navigator.serviceWorker.getRegistration('/').then(registration => {
      if (!registration) {
        navigator.serviceWorker.register('/firebase-messaging-sw.js', { scope: '/' })
          .then(reg => console.log('[ServiceWorker] Messaging SW Registered', reg.scope))
          .catch(err => console.error('[ServiceWorker] Messaging SW Registration Failed', err));
      } else {
        console.log('[ServiceWorker] Messaging SW already active');
      }
    });
  });
}

initConsoleFilter();
app.mount('#app');
